import Layout from 'antd/lib/layout';
import React from 'react';
import './ApplicationStyles.css';
import {Sidebar} from '../Sidebar';
import {Routes} from '../Routes';
import {RegionProvider} from '../RegionProvider/RegionProvider';

const {Sider, Header, Footer} = Layout;

const Application: React.FC = () => (
  <RegionProvider>
    {(regions: Array<Region>) => {
      return (
        <Layout className="app-layout">
          <Sider>
            <Sidebar regions={regions} />
          </Sider>
          <Layout>
            <Header className="app-header" />
            <div className="page-wrapper">
              <Routes />
            </div>
            <Footer />
          </Layout>
        </Layout>
      );
    }}
  </RegionProvider>
);

export default Application;



// WEBPACK FOOTER //
// ./src/components/Application/Application.tsx